import { render, staticRenderFns } from "./miningRewardDetails.vue?vue&type=template&id=a7acc026&scoped=true&"
import script from "./miningRewardDetails.vue?vue&type=script&lang=js&"
export * from "./miningRewardDetails.vue?vue&type=script&lang=js&"
import style0 from "./miningRewardDetails.vue?vue&type=style&index=0&id=a7acc026&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7acc026",
  null
  
)

export default component.exports